import { render, staticRenderFns } from "./NoteLandingPage.vue?vue&type=template&id=0424ea1c&scoped=true"
import script from "./NoteLandingPage.vue?vue&type=script&lang=js"
export * from "./NoteLandingPage.vue?vue&type=script&lang=js"
import style0 from "./NoteLandingPage.vue?vue&type=style&index=0&id=0424ea1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0424ea1c",
  null
  
)

export default component.exports